import { VStack } from '@ayble-health/dashboard-components';
import { EliminationDetailsContent } from 'components/UserDashboard/overview/EliminationDetailsContent';
import { FoodChallengeDetailsContent } from 'components/UserDashboard/overview/FoodChallengeDetailsContent';
import { SuspectIdentificationDetailsContent } from 'components/UserDashboard/overview/SuspectIdentificationDetailsContent';
import { BLOCK_STABLE_STRINGS, UserBlock } from 'models/block';

type Props = {
  block: UserBlock;
};

export const BlockOverview = ({ block }: Props) => {
  const renderContent = () => {
    switch (block.stable_string) {
      case BLOCK_STABLE_STRINGS.eliminationChallenge:
        return <EliminationDetailsContent blockId={block.id} />;
      case BLOCK_STABLE_STRINGS.foodChallenge:
        return <FoodChallengeDetailsContent blockId={block.id} />;
      case BLOCK_STABLE_STRINGS.identifySuspects:
        return <SuspectIdentificationDetailsContent blockId={block.id} />;
      default:
        return null;
    }
  };

  return (
    <VStack py={2} px={6}>
      {renderContent()}
    </VStack>
  );
};

export default BlockOverview;
